import {throttle} from './../../../shared/pipes/throttle';
import {HttpWrapperOptions, httpService} from '../../../shared/httpWrapper';
import {apiUrls} from '../../../shared/constants/urls';
import {getApiRoute} from '../../../shared/pipes/getApiRoute';
import {AppThunk} from '../index';
import {ProductResponsePayload} from '../../../shared/models/api/productResponsePayload';
import {ProductsListRequestPayload} from '../../../shared/models/api/productsListRequestPayload';
import {productsSlice} from '../../reducers/products';
import {MarketFilterOptionsResponsePayload} from '../../../shared/models/api/marketFilterOptionsResponsePayload';
import {ProductDetailedResponsePayload} from '../../../shared/models/api/productDetailedResponsePayload';

export const setProductsByFilters = (filters: ProductsListRequestPayload): AppThunk => {
  return async (dispatch) => {
    throttle(async () => {
      const productsList = await httpService.post<ProductResponsePayload>(
        getApiRoute(apiUrls.setProductsByFilters),
        filters,
        new HttpWrapperOptions().Wait(true).Errors(true).ThrowException(true),
      );
      if (productsList) {
        dispatch(productsSlice.actions.setProducts(productsList));
      }
    }, 900);
  };
};

export const getDetailedProduct = (id: string): AppThunk => {
  return async (dispatch) => {
    if (!id) {
      return;
    }
    const detailedPruduct = await httpService.get<ProductDetailedResponsePayload>(
      getApiRoute(apiUrls.getProductDetails, {productId: id}),
      new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
    );
    if (!detailedPruduct) return;
    dispatch(productsSlice.actions.setDetailedProduct(detailedPruduct));
  };
};

export const getListProductCategories = (): AppThunk => {
  return async (dispatch) => {
    throttle(async () => {
      const list = await httpService.get<MarketFilterOptionsResponsePayload>(
        getApiRoute(apiUrls.getProductFiltersList),
        new HttpWrapperOptions().Errors(true),
      );
      if (list) {
        dispatch(productsSlice.actions.setListProductCategories(list.categoriesFilterOptions));
      }
    }, 900);
  };
};

export const getListProductAcceptors = (): AppThunk => {
  return async (dispatch) => {
    throttle(async () => {
      const list = await httpService.get<MarketFilterOptionsResponsePayload>(
        getApiRoute(apiUrls.getProductFiltersList),
        new HttpWrapperOptions().Errors(true),
      );
      if (list) {
        dispatch(productsSlice.actions.setListProductAcceptors(list.acceptorsFilterOptions));
      }
    }, 900);
  };
};
